import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

import type {Anchor, Color} from './types'

export const sidePanel = css`
  border-radius: 0;
`
export const anchor: Partial<Record<Anchor, string>> = {
  // расширять по мере необходимости
  right: css`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    left: 0;

    && {
      max-width: initial;
    }
  `,
  bottom: css`
    top: 0;
  `,
}
export const color: Partial<Record<Color, string>> = {
  // расширять по мере необходимости
  minor: css`
    background: ${cssTheme.default.day.backgroundMinor};
  `,
}
